import { useState } from "react";
import Port2Graph from "./Port2GraphView";
import "../../css/Port2View.css";
import { useSelector } from "react-redux";
import { Port2UpdatedTime } from "./Port2Slice";

export type PeriodType = "累計" | "今月" | "先月";

const Port2 = () => {
  const [period, setPeriod] = useState<PeriodType>("今月");

  const ChangePeriod = (item: PeriodType) => {
    setPeriod(item);
  };

  const port2UpdatedTime = useSelector(Port2UpdatedTime);

  return (
    <div className="position_row">
      <div className="dashboard_container_port2">
        <h1 className="dashboard_title_port2">
          利用状況 -中村区、中川区- ({period})
        </h1>
        <div className="button_container_port2">
          <button
            className="period_item_port2"
            onClick={() => ChangePeriod("累計")}>
            累計
          </button>
          <button
            className="period_item_port2"
            onClick={() => ChangePeriod("今月")}>
            今月
          </button>
          <button
            className="period_item_port2"
            onClick={() => ChangePeriod("先月")}>
            先月
          </button>
        </div>
        <div className="time_msg">※データは1分ごとに自動更新されます</div>
        <div className="dashbaord_time">最終更新時間 : {port2UpdatedTime}</div>
        <div className="graph_container_port2">
          <Port2Graph period={period} />
        </div>
      </div>
    </div>
  );
};

export default Port2;
